<div class="modal-header">
    <h5 class="modal-title">
        Document
    </h5>
</div>

<div class="modal-body" style="width:fit-content;margin:auto;">
    <img [src]="data.fileURL" style="width: 100%">
</div>